import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface CategoryTabsProps {
  activeSlug?: string;
}

export default function CategoryTabs({ activeSlug }: CategoryTabsProps) {
  const location = useLocation();

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2">
      <Link
        to="/"
        className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
          location.pathname === '/' || !activeSlug
            ? 'bg-primary-500 text-white'
            : 'bg-background-100 text-foreground-600 hover:bg-background-200'
        }`}
      >
        全部
      </Link>
      {categories.map((cat) => (
        <Link
          key={cat.id}
          to={`/category/${cat.slug}`}
          className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
            activeSlug === cat.slug
              ? 'bg-primary-500 text-white'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200'
          }`}
        >
          {cat.name}
        </Link>
      ))}
    </div>
  );
}